import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./baseQuery";

export const commentsApi = createApi({
  reducerPath: "commentsApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Comment"],
  endpoints: (builder) => ({
    getComments: builder.query({
      query: ({ recordType, recordId }) => ({
        url: `/comments/${recordType}/${recordId}`,
      }),
      providesTags: (result, error, arg) => [
        { type: "Comment", id: `${arg.recordType}-${arg.recordId}` },
      ],
    }),
    createComment: builder.mutation({
      query: (body) => ({
        url: "/comments",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Comment", id: `${arg.record_type}-${arg.record_id}` },
      ],
    }),
    deleteComment: builder.mutation({
      query: (id) => ({
        url: `/comments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Comment"],
    }),
  }),
});

export const {
  useGetCommentsQuery,
  useCreateCommentMutation,
  useDeleteCommentMutation,
} = commentsApi;
